export default class AtoMovimento {

  constructor(atoMovimento) {
    this.livro = atoMovimento.livro;
    this.folhaInicial = atoMovimento.folhaInicial;
    this.folhaFinal = atoMovimento.folhaFinal;
    this.dataMovimento = atoMovimento.dataMovimento;
    this.exercicio = atoMovimento.exercicio;
    this.descricao = atoMovimento.descricao;
    this.atoMovimentoCampo = atoMovimento.atoMovimentoCampo;
  }

}



// WEBPACK FOOTER //
// ./src/domain/selo/ato-movimento.js